export default __webpack_public_path__ + "static/media/FX3.ac47cf99.mp3";